const nzFormats = {
  number: {
    LOCALE_CURRENCY: {
      style: 'currency',
      currency: 'NZD',
    },
  },
  date: {
    LOCALE_DATE: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
  },
};

export { nzFormats };
